
import UMUM from "../../library/umum";

export default {
  data() {
    return {
      form: {
        id: "",
        tahun: "",
        indikator: "",
        kecamatan: "",
        a: 0,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0,
        g: 0,
        h: 0,
        nama: "",
        jenis: "",
        tgl: null,
        status1: "",
        status2: "",
        status3: "",
        status4: "",
        status5: "",
        keterangan: "",
        createAt: "",
        editedAt: "",
      },

      tahun: "",
      sumber: "",
      kendala: "",
      total1: "",
      total2: "",
      total3: "",
      total4: "",
      total5: "",
      total6: "",
      total7: "",
      total8: "",
      indikator: "",
      nama_tahun: "",
      nama_kadis: "",
      nip_kadis: "",
      pangkat_kadis: "",
      gol_kadis: "",
      ruang_kadis: "",
      gel_bel_kadis: "",
      gel_dep_kadis: "",

      list_data: [],
      cetak_data: [],
      list_tahun: [],
      list_kecamatan: [],
      list_indikator: [],

      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data: true,

      mdl_add: false,
      mdl_cetak: false,
      mdl_print: false,
      mdl_download: false,
      mdl_edit: false,
      mdl_hapus: false,
      btn_add: false,

      UMUM: UMUM,
    };
  },
  computed: {
    // subTotalCols() {
    //   const cols = this.indikatorSchema.table.sumColumns;
    //   const rows = this.normalizedCetakRows;

    //   const totals = {};

    //   cols.forEach((c) => (totals[c] = 0));

    //   rows.forEach((r) => {
    //     cols.forEach((c) => {
    //       totals[c] += Number(r[c] || 0);
    //     });
    //   });

    //   return totals;
    // },

    nonSumColCount() {
    const body = this.indikatorSchema.table.bodyColumns
    const sumCols = this.indikatorSchema.table.sumColumns || []

    let count = 0

    for (let col of body) {
      if (sumCols.includes(col) || col === 'percentage') {
        break
      }
      count++
    }

    return count
  },

    subTotalCols() {
      const cols = this.indikatorSchema.table.sumColumns;
      const rows = this.normalizedCetakRows;

      const totals = {};

      cols.forEach((c) => (totals[c] = 0));

      rows.forEach((r) => {
        cols.forEach((c) => {
          totals[c] += Number(r[c] || 0);
        });
      });

      return totals;
    },

    grandTotal() {
      const cols =
        this.indikatorSchema.table.sumColumns ||
        this.indikatorSchema.table.bodyColumns;
      return cols.reduce(
        (sum, c) => sum + Number(this.subTotalCols[c] || 0),
        0,
      );
    },
    indikatorSchema() {
      const id = Number(this.form?.indikator?.id);

      // helper cepat
      const num = (v) => Number(v || 0);

      const isCetak = this.mdl_cetak;

      // =========================
      // INDIKATOR 1
      // =========================
      if (id === 1 || id === 2) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                { label: "Jumlah Penanggungjawab Usaha dan/atau Kegiatan", rowspan: 2 },
                { label: "Jenis Usaha/Kegiatan", colspan: 7 },
                { label: "Ket", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Agroindustri" },
                { label: "Manufaktur" },
                { label: "Prasarana" },
                { label: "Jasa" },
                { label: "Pertambangan" },
                { label: "Energi" },
                { label: "Migas" },
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["kecamatan","a", "b", "c", "d", "e", "f", "g", "h"],
            sumColumns: ["a", "b", "c", "d", "e", "f", "g", "h"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "a",
                    label: "Jumlah Penanggungjawab Usaha dan/atau Kegiatan",
                    type: "number",
                  },
                ],
              },
              {
                title: "Jenis Usaha/Kegiatan",
                cols: 2,
                fields: [
                  {
                    key: "b",
                    label: "Agroindustri",
                    type: "number",
                  },
                  {
                    key: "c",
                    label: "Manufaktur",
                    type: "number",
                  },
                ],
              },
              {
                cols: 2,
                fields: [
                  {
                    key: "d",
                    label: "Prasarana",
                    type: "number",
                  },
                  {
                    key: "e",
                    label: "Jasa",
                    type: "number",
                  },
                ],
              },
              {
                cols: 3,
                fields: [
                  {
                    key: "f",
                    label: "Pertambangan",
                    type: "number",
                  },
                  {
                    key: "g",
                    label: "Energi",
                    type: "number",
                  },
                  {
                    key: "h",
                    label: "Migas",
                    type: "number",
                  },
                ],
              },
            ],
            showKec: true,
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);
            const d = num(row.d);
            const e = num(row.e);
            const f = num(row.f);
            const g = num(row.g);
            const h = num(row.h);

            return {
              ...row,
              a,
              b,
              c,
              d,
              e,
              f,
              g,
              h,
            };
          },
        };
      }
      // =========================
      // INDIKATOR 2
      // =========================
      if (id === 3) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Nama Perusahaan", rowspan: 2, width: "12%" },
                { label: "Jenis Usaha/Kegiatan", rowspan: 2, width: "12%" },
                { label: "Kec", rowspan: 2, width: "12%" },
                { label: "Tanggal Penerbitan Izin", rowspan: 2, width: "12%" },
                { label: "Status Ketaatan terhadap Izin Lingkungan, Izin PPLH, Izin PPU", colspan: 5 },
                { label: "Ket", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Dokumen Lingkungan" },
                { label: "Pengendalian Pencemaran Air (PPA)" },
                { label: "Pengendalian Pencemaran Udaha (PPU)" },
                { label: "Pengelolaan B3" },
                { label: "Pengelolaan Sampah Domestik" },
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["nama","jenis","kecamatan","tgl","status1", "status1", "status1", "status1", "status5"],
            sumColumns: ["a", "b", "c", "total"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "nama",
                    label: "Nama Perusahaan",
                    type: "text",
                  },
                  {
                    key: "jenis",
                    label: "Jenis Usaha/Kegiatan",
                    type: "text",
                  },
                  {
                    key: "tgl",
                    label: "Tanggal Penerbitan Izin",
                    type: "date",
                  },
                ],
              },
              {
                title: "Status Ketaatan terhadap Izin Lingkungan, Izin PPLH, Izin PPU",
                cols: 2,
                fields: [
                  {
                    key: "status1",
                    label: "Dokumen Lingkungan",
                    type: "text",
                  },
                  {
                    key: "status2",
                    label: "Pengendalian Pencemaran Air (PPA)",
                    type: "text",
                  },
                ],
              },
              {
                cols: 3,
                fields: [
                  {
                    key: "status3",
                    label: "Pengendalian Pencemaran Udara",
                    type: "text",
                  },
                  {
                    key: "status4",
                    label: "Pengelolaan B3",
                    type: "text",
                  },
                  {
                    key: "status5",
                    label: "Pengelolaan Sampah Domestik",
                    type: "text",
                  },
                ],
              },
            ],
            showKec: true,
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const tgl = row.tgl
              ? new Date(row.tgl).toLocaleDateString("id-ID")
              : "";

            return {
              ...row,
              tgl,
            };
          },
        };
      }

      // =========================
      // DEFAULT
      // =========================
      return {
        id,
        table: {
          headRows: [],
          bodyColumns: [],
          showTotal: false,
          showKet: false,
          showAksi: !isCetak,
        },
        form: {
          groups: [],
          showKet: false,
        },
        calcRow: (row) => row,
      };
    },

    // ini dipakai untuk table view
    normalizedRows() {
      return (this.list_data || []).map(this.indikatorSchema.calcRow);
    },

    // ini dipakai untuk cetak
    normalizedCetakRows() {
      return (this.cetak_data || []).map(this.indikatorSchema.calcRow);
    },
  },

  methods: {
    getCellValue(row, key) {
      return row[key] ?? 0;
    },
    formatDate(val) {
      if (!val) return "-";

      const d = new Date(val);
      if (isNaN(d)) return val;

      return d.toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    },
    getView: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_DLH + "viewData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          tahun: this.form.tahun.id,
          indikator: this.form.indikator.id,
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log("dasf");

          console.log(res_data);
          console.log("dasf");
          this.list_data = res_data.data;
          this.cetak_data = res_data.cetak;
          this.page_last = res_data.jml_data;
          this.$store.commit("hideLoading");
          this.nama_tahun = res_data.data[0].thn;
          this.indikator = res_data.data[0].indikator;
        });
    },

    getTotal: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_TOTAL + "DLHData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({
          tahun: this.form.tahun.id,
          indikator: this.form.indikator.id,
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          this.$store.commit("hideLoading");
          this.total1 = res_data.data[0].total1;
          this.total2 = res_data.data[0].total2;
          this.total3 = res_data.data[0].total3;
          this.total4 = res_data.data[0].total4;
          this.total5 = res_data.data[0].total5;
          this.total6 = res_data.data[0].total6;
          this.total7 = res_data.data[0].total7;
          this.total8 = res_data.data[0].total8;
          console.log(res_data);
        });
    },

    getKadis: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Unit + "kadis", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.nama_kadis = res_data[0].nama;
          this.nip_kadis = res_data[0].nip;
          this.pangkat_kadis = res_data[0].pangkat;
          this.gol_kadis = res_data[0].gol;
          this.ruang_kadis = res_data[0].ruang;
          this.gel_dep_kadis = res_data[0].gelar_depan;
          this.gel_bel_kadis = res_data[0].gelar_belakang;
          this.$store.commit("hideLoading");
        });
    },

    getKecamatan: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Kecamatan + "view", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_kecamatan = res_data;

          console.log(this.list_kecamatan);
          this.$store.commit("hideLoading");
        });
    },

    getTahun: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Tahun, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_tahun = res_data;
          this.$store.commit("hideLoading");
        });
    },

    getIndikator: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_DLH + "indikator", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_indikator = res_data;
          this.$store.commit("hideLoading");
        });
    },
    printTable() {
      const printWindow = window.open("", "_blank");
      const content = document.getElementById("printCetak").innerHTML;

      const style = `
    <style>
      @page { margin: 10mm; }

      body {
        font-family: Arial, sans-serif;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        margin: 0;
        padding: 0;
      }

      table {
        width: 100%;
        border-collapse: collapse;
      }

      th, td {
        border: 1px solid #ddd;
        padding: 5px;
        font-size: 11px;
        white-space: normal;
      }

      .text-center {
        text-align: center !important;
      }

      .print-wrapper {
        transform-origin: top left;
        display: inline-block;
      }
    </style>
  `;

      printWindow.document.open();
      printWindow.document.write(`
    <html>
      <head>
        <title>Dinas Lingkungan Hidup</title>
        ${style}
      </head>
      <body>
        <div id="wrapper" class="print-wrapper">
          ${content}
        </div>
      </body>
    </html>
  `);
      printWindow.document.close();

      printWindow.onload = function () {
        const wrapper = printWindow.document.getElementById("wrapper");

        // lebar halaman yang sedang aktif (portrait/landscape ikut user)
        const pageWidth = printWindow.innerWidth;

        // lebar tabel / konten
        const contentWidth = wrapper.scrollWidth;

        if (contentWidth > pageWidth) {
          const scale = pageWidth / contentWidth;
          wrapper.style.transform = `scale(${scale})`;
        } else {
          wrapper.style.transform = "scale(1)";
        }

        printWindow.focus();
        printWindow.print();
      };
    },
    addData: function () {
      // var formData = new FormData();
      // formData.append('data', JSON.stringify(this.form))
      fetch(this.$store.state.url.URL_DLH + "addData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify(this.form),
      }).then((res_data) => {
        this.Notify(
          "Sukses Menambah Data",
          "light-blue-4",
          "check_circle_outline",
        );
        console.log(res_data);
        this.getView();
      });
    },

    editData: function () {
      console.log(this.form);
      fetch(this.$store.state.url.URL_DLH + "editData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify(this.form),
      }).then((res_data) => {
        this.Notify("Sukses Merubah Data", "lime-7", "check_circle_outline");
        this.getView();
      });
    },

    removeData: function (a) {
      fetch(this.$store.state.url.URL_DLH + "removeData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({ id: a }),
      }).then((res_data) => {
        this.Notify(
          "Sukses Menghapus Data",
          "deep-orange-10",
          "check_circle_outline",
        );
        this.getView();
      });
    },

    selectData: function (data) {
      this.form.id = data.id;
      this.form.a = data.a;
      this.form.b = data.b;
      this.form.c = data.c;
      this.form.d = data.d;
      this.form.e = data.e;
      this.form.f = data.f;
      this.form.g = data.g;
      this.form.h = data.h;
      this.form.nama = data.nama;
      this.form.jenis = data.jenis;
      this.form.tgl = data.tgl;
      this.form.status1 = data.status1;
      this.form.status2 = data.status2;
      this.form.status3 = data.status3;
      this.form.status4 = data.status4;
      this.form.status5 = data.status5;
      this.form.keterangan = data.keterangan;
      this.form.createAt = data.createAt;
    },

    // ====================================== PAGINATE ====================================
    Notify: function (message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: "top",
        timeout: 500,
      });
    },
    btn_prev: function () {
      this.cek_load_data = true;
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function () {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function () {
      this.page_first = 1;
      this.getView();
    },

    // ====================================== PAGINATE ====================================
  },

  mounted() {
    this.getView();
    this.getTahun();
    this.getKadis();
    this.getIndikator();
    this.getKecamatan();
  },
};
